import { inject } from 'mobx-react';
import React, { Component } from 'react';
import { DataAttributes, DataAttributesBuilder } from '../../services/DataAttributesBuilder';
import {
    ContentDefinitionListUrlParams
} from '../../stores/contentDefinitionListStore/contentDefinitionListStoreModel';
import { Aside, AsideItem, FilterBySearch } from '../index';
import { DefinitionListFiltersProps, DefinitionListFiltersState, InjectedProps } from './DefinitionListFiltersModel';

@inject('contentDefinitionListStore')
class DefinitionListFilters extends Component<DefinitionListFiltersProps, DefinitionListFiltersState> {
    get injected() {
        return this.props as InjectedProps;
    }

    onResetFilters = () => {
        this.injected.contentDefinitionListStore.searchParams.deleteAllUrlParams();
    }

    searchContentDefinitions = (value?: string) => {
        this.injected.contentDefinitionListStore.searchParams.setUrlParam(
            ContentDefinitionListUrlParams.byName, value);
    }

    createSearchDataAttributes = (): DataAttributes => {
        return new DataAttributesBuilder('content-definitions')
            .setSearchAttribute('search')
            .build();
    }

    render() {
        const { contentDefinitionListStore: { searchParams: { usableSearchParams, urlSearchParams } } } = this.injected;
        return (
            <Aside>
                <AsideItem>
                    <FilterBySearch
                        dataAttributes={this.createSearchDataAttributes}
                        defaultValue={urlSearchParams.has(ContentDefinitionListUrlParams.byName)
                            ? usableSearchParams[ContentDefinitionListUrlParams.byName]
                            : undefined
                        }
                        onSearch={this.searchContentDefinitions}
                    />
                </AsideItem>
            </Aside>
        );
    }
}

export default DefinitionListFilters;
